import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { ComponentHelper } from "../../core/util/componentHelper";
import { DropDownList } from "../../core/components/dropDownList";
import { Helper } from "../../core/util/helper";
import { Config } from "../../core/config/config";
import { FileUpload, File } from "../../core/components/fileUpload";
import { Button } from "../../core/components/button";
import { Dialog, DialogProps } from "../../core/components/dialog";
import { FullHeightContainer } from "../../core/components/FullHeighContainer";
import { DialogHelper } from "../../core/util/dialogHelper";
import React from "react";

export default class EditDefaultImage extends React.Component<any, EditDefaultImageState> {
    private factory = ComponentHelper.createFactory();
    private dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.close,
                action: () => {


                },
                primary: true
            }
        ],
        afterClose: () => {
            this.setState({ dialogOpen: false });
        },
        width: 480
    };
    private translations: string[] = [];

    constructor(props) {
        super(props)
        this.translations = props.context.translations;
        this.state = {
            images: null,
            selected: null,
            dialogOpen: false
        };
        this.loadData();
    }
    //Logic
    private loadData = () => {
        HTTPService.get<JsonResultClass<DynamicSearchDefaultImage[]>>("DynamicSearchSettings/GetImages")
            .then(result => {
                if (result.Code === 0) {
                    this.setState({ images: result.Data, selected: result.Data[0] });
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            }); 
    }
    private deleteImage = () => {
        let selected = this.state.selected;
        HTTPService.get<JsonResultClass>("DynamicSearchSettings/DeleteImage?searchType=" + selected.SearchType).then((result) => {
            if (result.Code === 0) {
                let images = this.state.images;
                const index = images.findIndex(f => f.SearchType === selected.SearchType);
                selected.Image = null;
                images[index] = selected;
                this.setState({ images: images, selected: selected })
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        });
    }
    private editImage = (file: File) => {
        let selected = this.state.selected;
        const formData = new FormData();
        formData.append("file", file.rawFile);
        formData.append("searchType", selected.SearchType);
        HTTPService.post<JsonResultClass<DynamicSearchDefaultImage>>("DynamicSearchSettings/EditImage", formData)
            .then((result) => {
                if (result.Code === 0) {
                    let images = this.state.images;
                    const index = images.findIndex(f => f.SearchType === selected.SearchType);
                    selected.Image = result.Data.Image;
                    images[index] = selected;
                    this.setState({ images: images, selected: selected, dialogOpen: false })
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
        });
    }
    //Edit bar
    private createEditBar = () => {
        return (
            <div style={{ display: "flex", flexDirection: "row" }}>
                {this.createDropDownList()}
                {this.createButtons()}
            </div>
        );

    }
    private createDropDownList = () => {
        let props = this.factory.getDefaultDropDownProps()
        props.dataSource = this.state.images;
        props.value = this.state.selected.SearchType;
        props.field.dataTextField = "Designation";
        props.field.dataValueField = "SearchType";
        props.field.optionLabel = Config.translations.pleaseSelect;
        props.onChange = (field: any, value: any, dataItem: DynamicSearchDefaultImage) => {
            if (!Helper.isNullOrEmpty(value)) {
                this.setState({ selected: dataItem })
            } else {
                this.setState({});
            }
        }
        return (
            <div style={{ width: "250px" }}>
                <DropDownList {...props} />
            </div>
        );
    }
    private createButtons = () => {
        const style: React.CSSProperties = {
            height: "38px",
            marginLeft: "5px",
            marginRight: "5px",
            width: "fit-content",
            borderRadius: "6px"
        }
        const onEditClick = () => {
            this.setState({ dialogOpen: true });
        }
        const onDeleteClick = this.deleteImage;
        return (
            <>
                <Button buttonStyle={style} handleClick={onEditClick} iconName={"edit"} text={Config.translations.editLabel}  />
                <Button buttonStyle={style} readOnly={Helper.isNullOrEmpty(this.state.selected.Image)} handleClick={onDeleteClick} iconName={"times"} text={Config.translations.deleteLabel} />
            </>
        );

    }
    private createImage = () => {
        let body = (
            <>
            </>
        );

        if (Helper.isNullOrEmpty(this.state.selected.Image)) {
            body = (
                <>
                    <div style={{ margin: "40px" }}>
                        {Config.translations.noImage}
                    </div>
                </>
            );
        } else {
            body = (
                <>
                    <img src={this.state.selected.Image} style={{ marginTop: "5px", marginBottom: "5px", maxWidth: "275px", maxHeight: "175px" }} />
                </>
            );
        }
        return (
            <div style={{ display: "flex", justifyContent: "center" }}>
                {body}
            </div>
        );
    }
    //Dialog
    private createDialog = () => {
        return (
            <div>
                <Dialog {...this.dialogProps} open={this.state.dialogOpen} >
                    <FullHeightContainer>
                        {this.createUploader()}
                    </FullHeightContainer>
                </Dialog>
            </div>
        );
    }
    private createUploader = () => {
        return (
            <div>
                <FileUpload
                    style={{ width: "383px", marginLeft: "5px" }}
                    upload={this.uploadFile}
                    validate={this.validateFile}
                    uploadButton={true}
                />
            </div>
            );
    }
    private uploadFile = (file: File) => {
        this.editImage(file);
    }
    private validateFile = (file: File) => {
        
        console.log(file.size);
        //Bei Erweiterung auch übersetzung anpassen
        if (file.size <= 0) {
            DialogHelper.alert(this.translations["WebSMS.GeneralSettings.Search.EmptyFile"]);
            return false;
        //} else if (file.size > 267846) {
        //    DialogHelper.alert(this.translations["WebSMS.GeneralSettings.Search.FileToLarge"]);
        //    return false;
        } else if (file.extension === ".png") {
            return true;
        } else {
            DialogHelper.alert(this.translations["WebSMS.GeneralSettings.Search.SupportedDatatypes"]);
            return false;
        }
    }
    render() {
        const bar = Helper.hasValue(this.state.selected) ? this.createEditBar() : null;
        const image = Helper.hasValue(this.state.selected) ? this.createImage() : null;
        const dialog = Helper.hasValue(this.state.selected) ? this.createDialog() : null;
        return (
            <>
                {bar}
                {image}
                {dialog}
            </>);
    }
}

interface EditDefaultImageState
{
    images: DynamicSearchDefaultImage[];
    selected: DynamicSearchDefaultImage;
    dialogOpen: boolean;
}

interface DynamicSearchDefaultImage
{
    SearchType: string;
    Designation: string;
    Image: string;
}
